module.exports = __webpack_public_path__ + "img/logo_colored.aa00f781.svg";